import { Navigate } from 'react-router-dom';

/**
 * MUS-597: /plan once sold hardcoded prices, told a trialing account its trial had ended and led
 * to a payment page that no longer exists. It now goes to the roadmap, where the paywall shows for
 * an account that needs one, with the current prices.
 */
const Plan = () => <Navigate to="/roadmap" replace />;

export default Plan;
